import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { MonitoringProvider } from './context/MonitoringContext';
import AppRoutes from './routes/AppRoutes';
import './style/variables.scss';
import './style/portalStyles.scss';
import './style/DataGridList.scss';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ThemeProvider>
          <MonitoringProvider>
            <AppRoutes />
          </MonitoringProvider>
        </ThemeProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;